module.exports = __webpack_public_path__ + "img/monetize-apis-subscription-model-thumbnail.54d2dd50.jpg";